"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserForAdminEntity = void 0;
const me_entity_1 = require("./me.entity");
class UserForAdminEntity extends me_entity_1.MeEntity {
}
exports.UserForAdminEntity = UserForAdminEntity;
